import { parseEgkText } from "@omony/domain";
import type { Worker } from "tesseract.js";

/**
 * Lokales OCR im Browser (Standard, A06): Das Kartenbild verlässt das Gerät nicht.
 * Tesseract wird erst beim ersten Scan geladen und danach wiederverwendet.
 */
let worker: Promise<Worker> | null = null;

function getWorker() {
  worker ??= import("tesseract.js").then(({ createWorker, OEM }) =>
    createWorker(["deu", "eng"], OEM.LSTM_ONLY, {
      workerPath: "/ocr/worker.min.js",
      corePath: "/ocr/core",
      langPath: "/ocr/lang",
      workerBlobURL: false,
    }),
  );
  worker.catch(() => {
    worker = null;
  });
  return worker;
}

/** Vorab laden, sobald die Kamera läuft (die Wartezeit fällt dann nicht auf) */
export const warmUpOcr = () => void getWorker().catch(() => undefined);

export async function recognizeCard(canvas: HTMLCanvasElement) {
  const w = await getWorker();
  const { data } = await w.recognize(canvas);
  return parseEgkText(data.text);
}

export async function terminateOcr() {
  const w = worker;
  worker = null;
  if (w) await (await w).terminate().catch(() => undefined);
}
